import React from "react";
import { useTranslation } from "react-i18next";
import * as styles from "./floor-create-intro.module.scss";
import PinnedListHeader from "../pinned-list-header";
import wallsAnimation from "../../../../img/animations/animation-walls.gif";
import VelavuButton from "../../../../elements/velavu-button";
import PinnedList from "../pinned-list";

export interface FloorCreateIntroProps {
	onClose?: () => void;
	onNext?: () => void;
}

export default function FloorCreateIntro(props: FloorCreateIntroProps) {
	const { t } = useTranslation();

	return (
		<PinnedList className={styles.pinnedList}>
			<div className={styles.header}>
				<PinnedListHeader onClose={props.onClose} />

				<img className={styles.image} src={wallsAnimation} alt="" />
			</div>

			<div className={styles.content}>
				<h1 className={styles.title}>
					{t("dashboard.floor_create.intro.title")}
				</h1>
				<p className={styles.body}>
					{t("dashboard.floor_create.intro.body1")}
					<br />
					<br />
					{t("dashboard.floor_create.intro.body2")}
				</p>

				<VelavuButton
					onClick={props.onNext}
					fullWidth
					label={t("common.get_started")}
				/>
			</div>
		</PinnedList>
	);
}
